import { render, staticRenderFns } from "./ReplyFamilyOpinionTab.vue?vue&type=template&id=f24d3412&scoped=true&lang=pug"
import script from "./ReplyFamilyOpinionTab.vue?vue&type=script&lang=ts"
export * from "./ReplyFamilyOpinionTab.vue?vue&type=script&lang=ts"
import style0 from "./ReplyFamilyOpinionTab.vue?vue&type=style&index=0&id=f24d3412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24d3412",
  null
  
)

export default component.exports